
/**
 * В массиве field в параметр attribute можно передать массив, если для одного параметра необходимо проверить несолько условий
 * @param {Array} fields [{attribute(-s), className},...]
 * @param {JQuery} target
 * @param {JQuery} actionsWindow
 * @param {String} parents
 */
export const checkActionAttribute = (fields, target, actionsWindow, parents = 'tr.data-row') => {

    if (parents == null) {
        parents = 'tr.data-row';
    }
    for (const field of fields) {
        const { attribute, className } = field;

        if (Array.isArray(attribute)) {
            let flag = true;
            attribute.forEach(element => {
                if (!target.parents(parents)[0].hasAttribute(element)){
                    flag=false;
                }
            });
            if (flag) {
                actionsWindow.find(`.action.${className}`).removeClass('d-none');
            } else {
                actionsWindow.find(`.action.${className}`).addClass('d-none');
            }
        }else{
            if (target.parents(parents)[0].hasAttribute(attribute)) actionsWindow.find(`.action.${className}`).removeClass('d-none');
            else actionsWindow.find(`.action.${className}`).addClass('d-none');
        }
    }

}
